export enum Locale {
  EN = 'EN',
  IS = 'IS',
}
